import type { GetStaticProps, InferGetStaticPropsType } from 'next'
import type { ReactNode } from 'react'

import { Layout, Seo } from '@/components/generals'
import { BlogCard } from '@/components/landing/blog-card'
import { getBlogPosts } from '@/lib/cms'

const InsightsPage = ({ posts }: InferGetStaticPropsType<typeof getStaticProps>): ReactNode => {
    const [featured, ...rest] = posts

    return (
        <Layout>
            <Seo
                title='Articles for Orthodontic Practices'
                description='Articles from Czechmate Consulting on orthodontic practice growth, patient trust, treatment coordinator training and running a practice that fits your life.'
            />

            <>
                <div className='hero-section-secondary no-zindex' id='hero'>
                    <div className='container with-large-bottom-padding'>
                        <div className='hero-content'>
                            <div className='mdl-layout-grid insights-hero-grid'>
                                <div className='content'>
                                    <h1 className='hero-text-content no-margins'>
                                        <div className='hero-text-word'>
                                            <div className='hero-text-letter'>
                                                <div className='hero-text _1'>Articles</div>
                                            </div>
                                            <div className='hero-text-letter'>
                                                <div className='hero-text _2'>for</div>
                                            </div>
                                            <div className='hero-text-letter'>
                                                <div className='hero-text _3'>Orthodontic</div>
                                            </div>
                                            <div className='hero-text-letter'>
                                                <div className='hero-text _4'>Practices</div>
                                            </div>
                                        </div>
                                    </h1>
                                    <div className='margin-top-2em'>
                                        <div className='animation-on-page-load-1'>
                                            <div className='hero-description'>
                                                Practical reading on patient experience, treatment coordination and
                                                growing a practice that supports the life you want.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='content relative'>
                                    <span className='blog-hero-pattern-image animation-on-page-load-2' aria-hidden='true' />
                                    {/* Newsletter signup hidden: Czechmate does not run a newsletter. The SubscribeForm component stays in the codebase. */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='section-background' />
                </div>
                <div className="section animation-bottom-on-page-load" id='articles'>
                    <div className="container no-padding-top">
                        <div className="blog-big-wrapper mdl-dyn-list">
                            <div className="blog-big-collection mdl-dyn-items" role="list">
                                {featured ? <BlogCard post={featured} big /> : null}
                            </div>
                        </div>
                        <div className="blog-wrapper mdl-dyn-list">
                            <div className="blog-grid mdl-dyn-items" role="list">
                                {rest.map((post) => (
                                    <BlogCard key={post.slug} post={post} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </Layout>
    )
}

export const getStaticProps = (async () => {
    const posts = await getBlogPosts()
    return { props: { posts }, revalidate: 60 }
}) satisfies GetStaticProps

export default InsightsPage
